module.exports = __webpack_public_path__ + "img/Logo-VD-DarkBlue.a605f522.png";